import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 'calc(100% - 96px)',
    },
  },
  expertiseContent: {
    color: 'white',
  },
  placeholder: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginLeft: theme.spacing(1),
  },
  edit: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
  },
}))
